<script lang="ts">
    import "dayjs/locale/id";
    import "@splidejs/svelte-splide/css/core";

    dayjs.locale("id");

    import Time from "svelte-time";
    import { dayjs } from "svelte-time";
    import { goto } from "$app/navigation";
    import { Tooltip } from "@svelte-plugins/tooltips";
    import { Splide, SplideSlide } from "@splidejs/svelte-splide";

    export let client: any = [];
    export let post: any = {};
    export let formShareSocialMedia: boolean = false;
    export let idContent: number = 0;
    export let durationTimeCopyToClipboard: any = "";
    export let isCopyToClipboard: boolean = false;

    export let handleCopyLinkToClipboard: any;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<article
    class="border-1 rounded-[0.7rem] bg-[#FFF] group cursor-pointer h-auto hover:scale-[102%] hover:transition-all"
>
    <div class="flex flex-row w-full gap-1">
        <div
            class="rounded-l-[10px] min-w-[25%] max-w-[25%] relative overflow-hidden"
        >
            <img
                loading="lazy"
                src={`${
                    post?.featured_images?.data?.[0]?.original ||
                    post?.featured_images?.data?.[0]?.large ||
                    post?.featured_images?.data?.[0]?.medium ||
                    post?.featured_images?.data?.[0]?.thumb ||
                    post?.featured_images?.data?.[0]?.small
                }`}
                alt={post?.title}
                class="w-full h-full object-cover object-center"
            />
        </div>
        <div class="px-2 w-full">
            <div class="pt-[0.5rem]">
                <span
                    class="text-slate-800 capitalize font-semibold line-clamp-3 text-[17px] group-hover:text-opacity-80"
                    >{post?.title}</span
                >
            </div>
            <div class="pb-[11px] h-[3rem] mb-2">
                {#if post?.excerpt}
                    <span
                        class="text-slate-600 line-clamp-2 text-[14px] group-hover:text-opacity-80"
                        >{post?.excerpt}</span
                    >
                {:else}
                    <span
                        class="text-slate-600 line-clamp-2 text-[14px] group-hover:text-opacity-80"
                        >{post?.title}</span
                    >
                {/if}
            </div>
            <div class="h-[1rem] flex flex-row gap-1 items-center">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" class="mt-[2px] mr-[0.1rem]" width="18" height="18" aria-label="Tag Category" ><g><path d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"></path><path d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"></path></g></svg> -->
                {#if post?.categories?.data?.length > 0}
                    <Splide
                        class="cursor-grab"
                        options={{
                            gap: "10px",
                            wheel: true,
                            drag: "free",
                            type: "slide",
                            rewind: false,
                            autoWidth: true,
                            wheelSleep: 100,
                            waitForTransition: true,
                        }}
                        aria-label="News Categories"
                    >
                        {#each post?.categories?.data as category}
                            <SplideSlide>
                                <a
                                    href={`/news/categories/${category?.slug}`}
                                    class="item-category no-underline hover:no-underline bg-slate-300/20 hover:bg-slate-300/50 px-1 rounded-[0.3rem] transition-colors duration-200 flex items-center gap-1"
                                >
                                    <span
                                        class="text-[14px] font-medium text-slate-700"
                                        >{category?.name}</span
                                    >
                                </a>
                            </SplideSlide>
                        {/each}
                        <div class="splide__arrows hidden"></div>
                        <ul class="splide__pagination hidden"></ul>
                    </Splide>
                {:else}
                    <div
                        class="item-category no-underline hover:no-underline bg-slate-300/20 px-1 rounded-[0.3rem] transition-colors duration-200 flex items-center gap-1"
                    >
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-label="Uncategorized" class="FollowingTag-addTagIcon-KCc e2e-FollowingTag-AddIcon"><g><path d="M5.653 14.48a1.386 1.386 0 0 0 .985-.408l7.161-7.161a2.309 2.309 0 0 0 .68-1.642V1.391A1.4 1.4 0 0 0 13.085 0H9.21a2.307 2.307 0 0 0-1.642.68L.407 7.841a1.4 1.4 0 0 0 0 1.971l4.261 4.261a1.383 1.383 0 0 0 .985.407ZM13.085.929a.465.465 0 0 1 .465.465v3.875a1.384 1.384 0 0 1-.408.985l-7.161 7.162a.465.465 0 0 1-.657 0l-4.26-4.262a.466.466 0 0 1 0-.657l7.161-7.16A1.386 1.386 0 0 1 9.21.929Z"></path><path d="M10.763 5.11a1.394 1.394 0 1 0-1.394-1.393 1.395 1.395 0 0 0 1.394 1.393Zm0-1.858a.465.465 0 1 1-.465.465.465.465 0 0 1 .465-.465Z"></path></g><g transform="translate(7.75 4.919)"><circle cx="5.5" cy="5.5" r="5.5" transform="translate(.587 .002)" fill="#f5f8ff"></circle><path d="M6.087 1.003a4.5 4.5 0 1 0 4.5 4.5 4.5 4.5 0 0 0-4.5-4.5Zm2.812 4.781a.281.281 0 0 1-.281.281H6.649v1.969a.281.281 0 0 1-.281.281h-.562a.281.281 0 0 1-.281-.281V6.065H3.556a.281.281 0 0 1-.281-.281v-.562a.281.281 0 0 1 .281-.281h1.968V2.972a.281.281 0 0 1 .281-.281h.563a.281.281 0 0 1 .281.281V4.94h1.969a.281.281 0 0 1 .281.281Z"></path></g></svg> -->
                        <span class="text-[14px] font-medium text-slate-700"
                            >Uncategorized</span
                        >
                    </div>
                {/if}
            </div>
            <div class="flex flex-col w-full justify-between gap-1 pb-[10px]">
                <div class="mt-1 flex flex-col w-full justify-between">
                    <div
                        on:click={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            goto(`/news/${post?.slug}`);
                        }}
                        class={`news__content-footer-sosmed bg-[#F5F5F5]/60 rounded-[0.5rem] transition-all duration-200 ${
                            formShareSocialMedia && post?.id === idContent
                                ? "w-0 h-0 overflow-hidden invisible"
                                : "flex items-center justify-between py-[10px] px-[14px] mt-[18px] w-auto h-auto"
                        }`}
                    >
                        <div class="news__content-detail-info">
                            <span
                                class="text-slate-700 text-[0.8rem] font-semibold mb-1 line-clamp-1"
                            >
                                {#if post.author}
                                    {post.author}
                                {:else}
                                    Admin
                                {/if}
                            </span>
                            <span
                                class="text-[0.8rem] font-normal text-[#3E3232BF] block"
                            >
                                <Time
                                    timestamp={post?.published_at}
                                    format="D MMMM YYYY"
                                />
                            </span>
                        </div>
                        <Tooltip
                            style={{
                                style: {
                                    zIndex: 1000,
                                },
                            }}
                            position="top"
                            animation="fade"
                            content="Bagikan"
                            theme="custom-tooltip"
                        >
                            <button
                                class="share-button-desktop lg:flex hidden gap-x-2 rounded-[8px] transition-colors duration-200 cursor-pointer"
                                on:click={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    idContent = post?.id;
                                    formShareSocialMedia = true;
                                    clearTimeout(durationTimeCopyToClipboard);
                                    isCopyToClipboard = false;
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="text-gray-500"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 24 24"
                                    ><path
                                        fill="currentColor"
                                        d="m13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755M6 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
                                    /></svg
                                >
                            </button>
                        </Tooltip>
                        <button
                            class="share-button-mobile lg:hidden flex gap-x-2 rounded-[8px] transition-colors duration-200 cursor-pointer"
                            on:click={(event) => {
                                event.stopPropagation();
                                event.preventDefault();
                                formShareSocialMedia = true;
                                idContent = post?.id;
                            }}
                        >
                            <svg
                                width="26"
                                height="26"
                                viewBox="0 0 24 24"
                                fill="none"
                                ><path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.22 4.93a.42.42 0 0 1-.12.13h.01a.45.45 0 0 1-.29.08.52.52 0 0 1-.3-.13L12.5 3v7.07a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5V3.02l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.8a.42.42 0 0 1 .07.5zm-.1.14zm.88 2h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.14c.1.1.15.22.15.35a.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9V8.96c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1z"
                                    fill="currentColor"
                                ></path></svg
                            >
                        </button>
                    </div>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class={` bg-[#F5F5F5]/60 rounded-[0.5rem] transition-all duration-200 cursor-default ${formShareSocialMedia && post?.id === idContent ? "flex items-center justify-between py-[10px] px-[14px] mt-[18px]" : "w-0 h-0 overflow-hidden invisible"}`}
                    >
                        <div class="news__content-detail-info overflow-x-auto">
                            <Splide
                                class="cursor-grab"
                                options={{
                                    drag: "free",
                                    type: "slide",
                                    rewind: false,
                                    autoWidth: true,
                                }}
                                aria-label="News Categories"
                            >
                                <SplideSlide>
                                    {#if isCopyToClipboard}
                                        <button
                                            type="button"
                                            class="copy-to-clipboard pointer-events-none flex flex-col justify-center items-center group hover:bg-gray-200/50 transition-colors duration-200 rounded-[8px] p-1 cursor-pointer"
                                        >
                                            {#if post?.id === idContent}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30"
                                                    height="30"
                                                    viewBox="0 0 24 24"
                                                    ><path
                                                        fill="currentColor"
                                                        d="m10 15.17l9.192-9.191l1.414 1.414L10 17.999l-6.364-6.364l1.414-1.414z"
                                                    /></svg
                                                >
                                            {:else}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30"
                                                    height="30"
                                                    viewBox="0 0 24 24"
                                                    ><path
                                                        fill="currentColor"
                                                        d="M18.364 15.536L16.95 14.12l1.414-1.414a5 5 0 0 0-7.071-7.071L9.878 7.05L8.464 5.636l1.414-1.414a7 7 0 0 1 9.9 9.9zm-2.829 2.828l-1.414 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 0 0 7.07 7.071l1.415-1.414zm-.707-10.607l1.415 1.415l-7.072 7.07l-1.414-1.414z"
                                                    /></svg
                                                >
                                            {/if}
                                        </button>
                                    {:else}
                                        <button
                                            type="button"
                                            on:click={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                handleCopyLinkToClipboard(
                                                    `https://${client?.domain === "" ? `${client?.subdomain}.munio.id/news/${post?.slug}` : `${client?.domain}/news/${post?.slug}`}`,
                                                    post?.id,
                                                );
                                            }}
                                            class="copy-to-clipboard flex flex-col justify-center items-center group hover:bg-gray-200/50 transition-colors duration-200 rounded-[8px] p-1 cursor-pointer"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 24 24"
                                                ><path
                                                    fill="currentColor"
                                                    d="M18.364 15.536L16.95 14.12l1.414-1.414a5 5 0 0 0-7.071-7.071L9.878 7.05L8.464 5.636l1.414-1.414a7 7 0 0 1 9.9 9.9zm-2.829 2.828l-1.414 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 0 0 7.07 7.071l1.415-1.414zm-.707-10.607l1.415 1.415l-7.072 7.07l-1.414-1.414z"
                                                /></svg
                                            >
                                        </button>
                                    {/if}
                                </SplideSlide>
                                <SplideSlide>
                                    <!-- svelte-ignore a11y-invalid-attribute -->
                                    <a
                                        on:click={() => {
                                            window.open(
                                                `https://www.facebook.com/sharer/sharer.php?u=https://${client?.domain === "" ? `${client?.subdomain}.munio.id/${post?.slug}` : `${client?.domain}/${post?.slug}`}&title=${post?.title}&quote=&hashtag=`,
                                                "",
                                                "popup",
                                            );
                                        }}
                                        href="javascript:void(0);"
                                        class="fb-xfbml-parse-ignore share-facebook flex flex-col justify-center items-center group hover:bg-gray-200/50 transition-colors duration-200 p-1 rounded-[8px] cursor-pointer no-underline hover:no-underline"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="text-center text-[#1877F2]"
                                            width="30"
                                            height="30"
                                            viewBox="0 0 24 24"
                                            ><path
                                                fill="currentColor"
                                                d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202z"
                                            /></svg
                                        >
                                    </a>
                                </SplideSlide>
                                <SplideSlide>
                                    <!-- svelte-ignore a11y-invalid-attribute -->
                                    <a
                                        on:click={() => {
                                            window.open(
                                                `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.origin}/${post?.slug}&summary=${post?.title} - ${window.location.origin}/${post?.slug}`,
                                                "",
                                                "popup",
                                            );
                                        }}
                                        href="javascript:void(0);"
                                        class="share-linkedin flex flex-col justify-center items-center group hover:bg-gray-200/50 transition-colors duration-200 rounded-[8px] p-1 cursor-pointer no-underline hover:no-underline"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="30"
                                            height="30"
                                            viewBox="0 0 128 128"
                                            ><path
                                                fill="#0076b2"
                                                d="M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3"
                                            /><path
                                                fill="#fff"
                                                d="M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49a10.5 10.5 0 0 1 10.5-10.49m20.41 29h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z"
                                            /></svg
                                        >
                                    </a>
                                </SplideSlide>
                                <SplideSlide>
                                    <!-- svelte-ignore a11y-invalid-attribute -->
                                    <a
                                        on:click={() => {
                                            window.open(
                                                `https://twitter.com/intent/tweet?text=${post?.title} - ${window.location.origin}/${post?.slug}`,
                                                "",
                                                "popup",
                                            );
                                        }}
                                        href="javascript:void(0);"
                                        class="share-twitter flex flex-col justify-center items-center group hover:bg-gray-200/50 transition-colors duration-200 rounded-[8px] p-2 cursor-pointer no-underline hover:no-underline"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="text-center text-[#1877F2]"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 128 128"
                                            ><path
                                                d="M75.916 54.2L122.542 0h-11.05L71.008 47.06L38.672 0H1.376l48.898 71.164L1.376 128h11.05L55.18 78.303L89.328 128h37.296L75.913 54.2ZM60.782 71.79l-4.955-7.086l-39.42-56.386h16.972L65.19 53.824l4.954 7.086l41.353 59.15h-16.97L60.782 71.793Z"
                                            /></svg
                                        >
                                    </a>
                                </SplideSlide>
                                <div class="splide__arrows hidden"></div>
                                <ul class="splide__pagination hidden"></ul>
                            </Splide>
                        </div>
                        <Tooltip
                            style={{
                                style: {
                                    zIndex: 1000,
                                },
                            }}
                            position="top"
                            content="Tutup"
                            animation="fade"
                            theme="custom-tooltip"
                        >
                            <button
                                class="close-share-button lg:flex hidden gap-x-2 rounded-[0.7rem] transition-colors duration-200 cursor-pointer"
                                on:click={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    formShareSocialMedia = false;
                                    clearTimeout(durationTimeCopyToClipboard);
                                    isCopyToClipboard = false;
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    ><path
                                        fill="currentColor"
                                        fill-rule="evenodd"
                                        d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12L5.47 6.53a.75.75 0 0 1 0-1.06"
                                        clip-rule="evenodd"
                                    /></svg
                                >
                            </button>
                        </Tooltip>
                        <button
                            class="close-share-button lg:hidden flex gap-x-2 rounded-[8px] transition-colors duration-200 cursor-pointer"
                            on:click={() => {
                                formShareSocialMedia = false;
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                ><path
                                    fill="currentColor"
                                    fill-rule="evenodd"
                                    d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12L5.47 6.53a.75.75 0 0 1 0-1.06"
                                    clip-rule="evenodd"
                                /></svg
                            >
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</article>

<style lang="css">
    :global(.tooltip.custom-tooltip) {
        --tooltip-box-shadow: 0 !important;
        --tooltip-color: white !important;
        font-family: Helvetica, Arial, sans-serif;
    }
    .news-wrapper {
        border: 1px solid #e4e7eb;
    }
    .news__content-category::-webkit-scrollbar {
        display: none;
    }
    .news__content-category {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
</style>
